import type { ReactElement } from 'react'

import React from 'react'
import Head from 'next/head'
import tw from 'twin.macro'

import AppLayout from '@/providers/AppLayout'
import BaseuiProvider from '@/providers/baseui'
import ConditionallyRender from '@/components/ConditionallyRender'
import ClaimPage from '@/pages/claim/ClaimPage'

export default function SpiritClaimPage() {
  return (
    <BaseuiProvider>
      <Head>
        <title>Spirit | PhalaWorld</title>
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@PhalaWorld" />
        <meta name="twitter:title" content="Come and join #PhalaWorld - the first NFT digital progression platform built on #PhalaNetwork." />
        <meta name="twitter:image" content="https://nft-assets.phala.world/referrals/twitter-card-5a8c34c4.jpg" />
      </Head>
      <ConditionallyRender client>
        <ClaimPage />
      </ConditionallyRender>
    </BaseuiProvider>
  )
}

SpiritClaimPage.getLayout = (page: ReactElement) => {
  return (
    <AppLayout>
      {page}
    </AppLayout>
  )
}
